import gluten from './gluten-free.png';
import vegetarian from './vegetarian.png';

const labels = {
  'Gluten Free': gluten,
  Vegetarian: vegetarian,
};

export default labels;
